import { TRIGGER_TYPES } from '../../blocks/trigger';
import { HomeLoansDashboardInteractionEvent } from '../registeredEvents';
import { HomeLoansDashboardClickstreamEvent } from './HomeLoansDashboardClickstreamEvent';
import { HomeLoansDashboardBaseEventProps, getHomeLoansDashboardEvent } from './getHomeLoansDashboardEvent';
export type HomeLoansDashboardInteractionEventProps = {
    event: HomeLoansDashboardInteractionEvent;
} & HomeLoansDashboardBaseEventProps;

export const getHomeLoansDashboardInteractionEvent = ({
    event,
    lead_id,
    journey_stage_cd,
    variant_nm,
}: HomeLoansDashboardInteractionEventProps): HomeLoansDashboardClickstreamEvent =>
    getHomeLoansDashboardEvent({
        event,
        lead_id,
        journey_stage_cd,
        variant_nm,
        trigger_type_nm: TRIGGER_TYPES.INTERACTION,
    });
